module.exports = __webpack_public_path__ + "img/mountain-gray.f370d7a0.svg";